import React from 'react';
import { useNavigation } from '@react-navigation/native';

import Container from '@src/components/Container';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { Post } from '@src/types';

import { Item, Row, SubTitle, Title } from './styled';
import { Props, ScreenNavigationProp } from './types';
import useDummyPosts from './useDummyPosts';

const Screen: React.FC<Props> = () => {
  const { data } = useDummyPosts();
  const navigation = useNavigation<ScreenNavigationProp>();

  const handleItemPress = (post: Post) => {
    navigation.navigate('DummyPost', { post });
  };

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <Title>!Welcome to Utopia</Title>
        <SubTitle>
          We will show you top places to adventure in middle east, Stay tuned
          for new fantastic posts!
        </SubTitle>
        <Row>
          {data
            .filter(({ medias }) => medias.length > 0 && !!medias[0].source)
            .slice(0, 6)
            .map((post) => (
              <Item
                key={post.id}
                image={post.medias[0]?.source}
                description={post.content}
                title={post.place?.name}
                onPress={() => handleItemPress(post)}
              />
            ))}
        </Row>
      </Container>
    </>
  );
};

Screen.displayName = 'DummyExplore';

export default Screen;
